import { appConstants } from "JS/Helpers/Constants";
import { BaseService } from "../BaseService";
import { config } from "JS/Config";

export class ExternalSSOService extends BaseService {
    getExternalSSO = (resourceKey: string, partner: string) =>
        this.ngCall<string>("get", appConstants.ngEndpoints.ssoRedirect, {
            headers: {
                authorization: `Bearer ${config?.ngAccesstoken}`,
            },
            params: {
                resourceKey,
                partner,
            },
        });
}
